export const isMaterraNewYearsPackage = (ratePlanId: string) => {
  const ratePlanIds = ["609dfa1e-be80-45ca-b651-8b61ab2dca58", "69058389-e0fc-45b8-9ba1-c9552160cf2a"];

  return ratePlanIds.includes(ratePlanId);
};
